import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import api from "../services/apiClient";
import AuthService from "../services/authentication";
import PrescriptionTable from "./PrescriptionTable";
import LoadingComponent from "../helpers/LoadingComponent";
import PatientEditModal from "./PatientEditModal";
import { Button, Pagination, PageHeader } from "../ui";

function PatientDetail() {
  const { patient_id } = useParams();
  const [page, setPage] = useState(0);
  const [patient, setPatient] = useState(null);
  const [orders, setOrders] = useState([]);
  const [total_count, setTotalCount] = useState(0);
  const [showEditModal, setShowEditModal] = useState(false);
  const history = useHistory();
  let auth = AuthService.useAuth();

  useEffect(() => {
    api
      .get(`/api/practitioner/patient/${patient_id}?page=${page}`, {
        headers: auth.authHeader(),
      })
      .then((response) => {
        console.log(response);
        setPatient(response.data.patient);
        setOrders(response.data.orders);
        setTotalCount(response.data.total_count);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [patient_id, page]);

  const totalPages = Math.ceil(total_count / 20);

  const handlePatientUpdated = (updatedPatient) => {
    console.log("Patient updated:", updatedPatient);
    setPatient(updatedPatient);
  };

  const handleEditPatient = () => {
    setShowEditModal(true);
  };

  if (!patient || !orders) return <LoadingComponent />;

  return (
    <div className="mx-auto w-full max-w-screen-xl px-4">
      <PageHeader
        title={`${patient.patient_first_name} ${patient.patient_last_name}`}
        subtitle={patient.patient_email}
        action={
          <Button
            variant="secondary"
            className="px-3 py-1.5 text-xs"
            onClick={handleEditPatient}
          >
            Edit Details
          </Button>
        }
      />
      <PrescriptionTable orders={orders} history={history} />
      <Pagination
        page={page}
        totalPages={totalPages}
        totalCount={total_count}
        onPageChange={setPage}
      />

      <PatientEditModal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        patient={patient}
        onPatientUpdated={handlePatientUpdated}
      />
    </div>
  );
}

export default PatientDetail;
